import React, { useState, useEffect, useRef } from 'react';
import '../styles/DealerForm.css';
import { RegisterNewUser, checkUserExists } from "../services/Auth";
import { showSnackbar } from "../comopnents/snackbar";
import { IoWarningOutline } from "react-icons/io5";


const Dealer = () => {
  const [formData, setFormData] = useState({
    contactPerson: '',
    firmname: '',
    emailId: '',
    contactNo: '',
    password: '123456',
    country: 'India',
    state: '',
    city: '',
    area: '',
    pin: '',
    address: '',
    extra1: '',
    extra5: [],
    intrestedin: [],
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [loadingPincode, setLoadingPincode] = useState(false);
  const [pincodeError, setPincodeError] = useState("");

  const debounceTimer = useRef(null);

  const [userExist, setUserExist] = useState({
    emailId: '',
    contactNo: '',
    extra1: '',
    contactPerson: '',
    firmname: ''
  });

  const validateField = (name, value) => {
    switch (name) {
      case 'contactPerson':
        return !value ? 'Contact Person is required' : '';
      case 'firmname':
        return !value ? 'Firm Name is required' : '';
      case 'emailId':
        if (!value) return 'Email Id is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Enter valid email address';
        return '';
      case 'contactNo':
        if (!value) return 'Contact No. is required';
        if (!/^[0-9]{10}$/.test(value)) return 'Enter valid 10 digit phone number';
        return '';
      case 'password':
        if (!value) return 'Password is required';
        if (value.length < 6) return 'Password must be at least 6 characters';
        return '';
      case 'country':
        return !value ? 'Country is required' : '';
      case 'state':
        return !value ? 'State is required' : '';
      case 'city':
        return !value ? 'City is required' : '';
      case 'pin':
        if (!value) return 'Pincode is required';
        if (!/^[0-9]{6}$/.test(value)) return 'Enter valid 6 digit pincode';
        return '';
      case 'area':
        return !value ? 'Area is required' : '';
      case 'extra5':
        return !value || value.length === 0 ? 'Select at least one' : '';
      case 'intrestedin':
        return !value || value.length === 0 ? 'Select at least one' : '';
      case 'address':
        return !value ? 'Address is required' : '';
      case 'extra1':
        if (!value) return 'GST Number is required';
        if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value.toUpperCase())) return 'Enter a valid 15-character GST number';
        return '';
    }
  };

  const fetchPincodeDetails = async (pincode) => {
    setPincodeError("");
    try {
      setLoadingPincode(true);
      const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await response.json();
      if (data[0]?.Status === "Success" && data[0].PostOffice?.length > 0) {
        const postOffice = data[0].PostOffice[0];
        setFormData((prev) => ({
          ...prev,
          state: postOffice.State,
          city: postOffice.District,
          area: postOffice.Name,
        }));
      } else {
        setPincodeError("Invalid PIN Code");
        setFormData((prev) => ({ ...prev, state: "", city: "", area: "" }));
      }
    } catch {
      setPincodeError("Invalid PIN Code");
      setFormData((prev) => ({ ...prev, state: "", city: "", area: "" }));
    } finally {
      setLoadingPincode(false);
    }
  };

  useEffect(() => {
    if (formData.pin && /^[0-9]{6}$/.test(formData.pin)) {
      fetchPincodeDetails(formData.pin);
    }
  }, [formData.pin]);

  const checkUser = async (field, value) => {
    if (!value || value.length < 3) {
      setUserExist(prev => ({ ...prev, [field]: '' }));
      return;
    }

    const validationError = validateField(field, value);
    if (validationError) {
      setUserExist(prev => ({ ...prev, [field]: '' }));
      return;
    }

    setLoading(true);
    try {
      const response = await checkUserExists({ param: value });

      if (response.status === 200) {
        setUserExist(prev => ({ ...prev, [field]: 'Exists' }));
      } else {
        setUserExist(prev => ({ ...prev, [field]: '' }));
      }
    } catch (err) {
      setUserExist(prev => ({ ...prev, [field]: '' }));
      showSnackbar("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const onRegister = async (data) => {
    setSubmitLoading(true);
    try {
      const refer = localStorage.getItem('ReferalCode') || '';
      const payload = {
        firmname: data.firmname,
        username: data.emailId,
        email: data.emailId,
        first_name: data.contactPerson,
        mobile: data.contactNo,
        password: data.password,
        usertype: "Dealer",
        module_assign: "0",
        address: data.address,
        country: data.country,
        city: data.city,
        state: data.state,
        pin: data.pin,
        extra1: data.extra1 || '',
        extra5: (data.extra5 || []).join(","),
        intrestedin: (data.intrestedin || []).join(","),
        extra4: refer,
      };


      const res = await RegisterNewUser(payload);
      if (res?.status === 200) {
        showSnackbar("success", "Dealer registered successfully!");
        setFormData({
          contactPerson: '',
          firmname: '',
          emailId: '',
          contactNo: '',
          password: '',
          country: 'India',
          state: '',
          city: '',
          area: '',
          pin: '',
          address: '',
          extra1: '',
          extra5: [],
          intrestedin: [],
        });
        setErrors({});
        setTouched({});
        setUserExist({
          emailId: '',
          contactNo: '',
          extra1: '',
          contactPerson: '',
          firmname: ''
        });
      } else {
        const errData = res?.data;
        if (errData && typeof errData === 'object') {
          const fieldMap = {
            username: 'emailId',
            email: 'emailId',
            mobile: 'contactNo',
            first_name: 'contactPerson',
            firmname: 'firmname',
            extra1: 'extra1',
          };
          const newUserExist = { ...userExist };
          let hasExistError = false;
          Object.entries(fieldMap).forEach(([backendField, formField]) => {
            if (errData[backendField]) {
              newUserExist[formField] = 'Exists';
              hasExistError = true;
            }
          });
          setUserExist(newUserExist);
          if (!hasExistError) {
            showSnackbar("error", errData?.msg || "Registration failed");
          }
        } else {
          showSnackbar("error", "Registration failed");
        }
      }
    } catch (error) {
      const errData = error?.response?.data;
      if (errData && typeof errData === 'object') {
        const fieldMap = {
          username: 'emailId',
          email: 'emailId',
          mobile: 'contactNo',
          first_name: 'contactPerson',
          firmname: 'firmname',
          extra1: 'extra1',
        };
        const newUserExist = { ...userExist };
        let hasExistError = false;
        Object.entries(fieldMap).forEach(([backendField, formField]) => {
          if (errData[backendField]) {
            newUserExist[formField] = 'Exists';
            hasExistError = true;
          }
        });
        setUserExist(newUserExist);
        if (!hasExistError) {
          showSnackbar("error", errData?.msg || "Registration failed");
        }
      } else {
        showSnackbar("error", errData?.msg || "Registration failed");
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const newTouched = {};

    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
      newTouched[key] = true;
    });

    setErrors(newErrors);
    setTouched(newTouched);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const finalValue = name === 'extra1' ? value.toUpperCase() : value;
    setFormData(prev => ({ ...prev, [name]: finalValue }));

    // Clear validation error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }

    // Clear existence error when user starts typing
    if (userExist[name] === 'Exists') {
      setUserExist(prev => ({ ...prev, [name]: '' }));
    }

    // Mark field as touched
    setTouched(prev => ({ ...prev, [name]: true }));

    // Clear pincode error when user modifies the pin
    if (name === 'pin' && pincodeError) {
      setPincodeError("");
    }

    // Debounced existence check — only fires 5s after user stops typing
    const fieldsToCheck = ['emailId', 'contactNo'];
    if (fieldsToCheck.includes(name)) {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
      debounceTimer.current = setTimeout(() => {
        checkUser(name, value);
      }, 5000);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));

    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));

    // Check existence on blur
    const fieldsToCheck = ['emailId', 'contactNo'];
    if (fieldsToCheck.includes(name) && !error && value) {
      checkUser(name, value);
    }
  };

  const dealsWithOptions = [
    "Garder Tools",
    "Generators",
    "Power Tools",
    "cordless",
    "Abrasives",
    "Vacuum Cleaners",
    "Compressors",
    "Welding Machines",
    "Accessories",
    "Common Spare parts",
  ];

  const intrestedInOptions = [
    "Garder Tools",
    "Generators",
    "Power Tools",
    "cordless",
    "Abrasives",
    "Vacuum Cleaners",
    "Compressors",
    "Welding Machines",
    "Accessories",
    "Common Spare parts",
  ];

  const toggleCheckbox = (name, value) => {
    setFormData((prev) => {
      const current = prev[name] || [];
      const exists = current.includes(value);
      return {
        ...prev,
        [name]: exists
          ? current.filter((item) => item !== value)
          : [...current, value],
      };
    });
    setTouched((prev) => ({ ...prev, [name]: true }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      showSnackbar("error", "Please fill all required fields correctly.");
      return;
    }

    // Check if any field has an existence error
    const hasExistsError = Object.values(userExist).some(status => status === 'Exists');
    if (hasExistsError) {
      showSnackbar("error", "Please correct the existing data errors before submitting.");
      return;
    }

    if (loading) {
      showSnackbar("info", "Please wait while we verify your information...");
      return;
    }

    onRegister(formData);
  };

  const hasError = (fieldName) => {
    return touched[fieldName] && errors[fieldName];
  };

  const userExists = (fieldName) => {
    return userExist[fieldName] === 'Exists';
  };

  return (
    <div className="dealer-container">
      <div className="form-header">
        <h2 className="form-title">Dealer Registration</h2>
        <p className="form-subtitle">Please fill in your details below</p>
      </div>

      <div className="form-wrapper">
        <div className="form-card">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  Contact Person<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('contactPerson') || userExists('contactPerson') ? 'input-error' : ''}`}
                  placeholder="Enter contact person name"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('contactPerson') && (
                  <div className="error-message">{errors.contactPerson}</div>
                )}
                {userExists('contactPerson') && (
                  <div className="error-message exists-error">
                    <span className="error-icon"><IoWarningOutline />
                    </span> Contact person already exists
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  Firm Name<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('firmname') || userExists('firmname') ? 'input-error' : ''}`}
                  placeholder="Enter your firm name"
                  name="firmname"
                  value={formData.firmname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('firmname') && (
                  <div className="error-message">{errors.firmname}</div>
                )}
                {userExists('firmname') && (
                  <div className="error-message exists-error">
                    <span className="error-icon"><IoWarningOutline />
                    </span> Firm name already exists
                  </div>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  Email Id<span className="required-star">*</span>
                </label>
                <input
                  type="email"
                  className={`form-input ${hasError('emailId') || userExists('emailId') ? 'input-error' : ''}`}
                  placeholder="Enter your email id"
                  name="emailId"
                  value={formData.emailId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('emailId') && (
                  <div className="error-message">{errors.emailId}</div>
                )}
                {userExists('emailId') && (
                  <div className="error-message exists-error">
                    <span className="error-icon"><IoWarningOutline />
                    </span> Email already exists
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  Contact No.<span className="required-star">*</span>
                </label>
                <input
                  type="tel"
                  className={`form-input ${hasError('contactNo') || userExists('contactNo') ? 'input-error' : ''}`}
                  placeholder="Enter 10 digit mobile number"
                  name="contactNo"
                  value={formData.contactNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('contactNo') && (
                  <div className="error-message">{errors.contactNo}</div>
                )}
                {userExists('contactNo') && (
                  <div className="error-message exists-error">
                    <span className="error-icon"><IoWarningOutline />
                    </span> Phone number already exists
                  </div>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  Password<span className="required-star">*</span>
                </label>
                <input
                  type="password"
                  className={`form-input ${hasError('password') ? 'input-error' : ''}`}
                  placeholder="Create a password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('password') && (
                  <div className="error-message">{errors.password}</div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  GST No<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('extra1') || userExists('extra1') ? 'input-error' : ''}`}
                  placeholder="Enter GST number"
                  name="extra1"
                  value={formData.extra1}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={15}
                  disabled={submitLoading}
                />
                {hasError('extra1') && (
                  <div className="error-message">{errors.extra1}</div>
                )}
                {userExists('extra1') && (
                  <div className="error-message exists-error">
                    <span className="error-icon"><IoWarningOutline />
                    </span> GST number already exists
                  </div>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  Pincode<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('pin') ? 'input-error' : ''}`}
                  placeholder="Enter 6 digit pincode"
                  name="pin"
                  value={formData.pin}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {loadingPincode && <div className="error-message">Fetching details...</div>}
                {pincodeError && <div className="error-message">{pincodeError}</div>}
                {hasError('pin') && (
                  <div className="error-message">{errors.pin}</div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  State<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('state') ? 'input-error' : ''}`}
                  placeholder="Auto-filled from pincode"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('state') && (
                  <div className="error-message">{errors.state}</div>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  City/District<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('city') ? 'input-error' : ''}`}
                  placeholder="Auto-filled from pincode"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('city') && (
                  <div className="error-message">{errors.city}</div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  Area/Locality<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('area') ? 'input-error' : ''}`}
                  placeholder="Auto-filled from pincode"
                  name="area"
                  value={formData.area}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('area') && (
                  <div className="error-message">{errors.area}</div>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  Address<span className="required-star">*</span>
                </label>
                <input
                  type="text"
                  className={`form-input ${hasError('address') ? 'input-error' : ''}`}
                  placeholder="Enter full address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={submitLoading}
                />
                {hasError('address') && (
                  <div className="error-message">{errors.address}</div>
                )}
              </div>

              <div className="form-group">
                <div style={{ visibility: 'hidden' }}>&nbsp;</div>
              </div>
            </div>

            <div className="form-row-full">
              <div className="form-group">
                <label className="form-label">
                  Deals With<span className="required-star">*</span>
                </label>
                <div className="checkbox-group">
                  {dealsWithOptions.map((option) => {
                    const selected = (formData.extra5 || []).includes(option);
                    return (
                      <button
                        type="button"
                        key={option}
                        className={`checkbox-item ${selected ? 'checkbox-item-selected' : ''}`}
                        onClick={() => toggleCheckbox('extra5', option)}
                      >
                        <span className={`checkbox ${selected ? 'checkbox-checked' : ''}`}>
                          {selected && '✓'}
                        </span>
                        <span className="checkbox-label">{option}</span>
                      </button>
                    );
                  })}
                </div>
                {hasError('extra5') && (
                  <div className="error-message">{errors.extra5}</div>
                )}
              </div>
            </div>

            <div className="form-row-full">
              <div className="form-group">
                <label className="form-label">
                  Interested In<span className="required-star">*</span>
                </label>
                <div className="checkbox-group">
                  {intrestedInOptions.map((option) => {
                    const selected = (formData.intrestedin || []).includes(option);
                    return (
                      <button
                        type="button"
                        key={option}
                        className={`checkbox-item ${selected ? 'checkbox-item-selected' : ''}`}
                        onClick={() => toggleCheckbox('intrestedin', option)}
                      >
                        <span className={`checkbox ${selected ? 'checkbox-checked' : ''}`}>
                          {selected && '✓'}
                        </span>
                        <span className="checkbox-label">{option}</span>
                      </button>
                    );
                  })}
                </div>
                {hasError('intrestedin') && (
                  <div className="error-message">{errors.intrestedin}</div>
                )}
              </div>
            </div>

            <div className="form-row-full">
              <button
                type="submit"
                className="submit-button"
                disabled={submitLoading || loading}
              >
                {submitLoading ? "Registering..." : "Register"}
              </button>
            </div>
            <div className="form-row-full">
              <button
                type="button"
                className="submit-button"
                onClick={() => window.open('https://pixeltools.in/test/assets/pixel.pdf', '_blank')}
              >
                View Catalogue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Dealer;